<template>
  <div>

    <base-header class="pb-6 bg-primary">

      <b-row class="align-items-center py-4">
        <b-col>

          <h6 class="h1 text-white header d-inline-block mb-0 fw-500" ref="topSection">
            Upload Policy Document
          </h6>
        </b-col>
      </b-row>
    </base-header>


    <div class="container-fluid mt--6">


      <div class="container-fluid mt--6" style="margin-top: -4.5rem !important">
        <b-card no-body class="mb-4 uBind">



          <b-card-header>
            <h2 style="font-size: 17pt" class="secondary-card-header">
              Please upload the policy document below.
            </h2>

            <!-- <h3 class="mb-0">Premium</h3> -->
          </b-card-header>
          <b-card-body>
            <div>
              Once uploaded, this will added to the YIHQ portal and be emailed to customer.
            </div>
            <div class="example-btn">
              <ul>
                <li v-for="(file, index) in fileList" :key="uploaderKey + '_file_' + index">
                  <div style="display: inline-block">{{ file.name }}</div>
                  <div v-if="!file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                    Please wait...file processing
                  </div>
                  <div v-if="file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                    Upload successful
                  </div>
                </li>
              </ul>
              <file-upload class="btn btn-primary btn-uploader" :custom-action="customAction" multiple
                extensions="gif,jpg,jpeg,png,webp,doc,docx,pdf,xls,xlsx,csv"
                accept="image/png,image/gif,image/jpeg,image/webp,application/msword,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                v-model="fileList" @input-filter="inputFilter" @input-file="inputFile" :input-id="uploaderKey"
                :ref="uploaderKey" active="true">
                <i class="fa fa-plus"></i>
                Select files
              </file-upload>


              <base-button :disabled="fileList.length == 0" v-if="!uploaded" :loading="isUploading" type="button"
                class="btn btn-success" @click="uploadFiles">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                Start Upload
              </base-button>
              <div style="display: inline-block; margin-left:20px;" v-if="uploaded">
                File upload completed, Please close window/tab.
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>

    </div>
  </div>
</template>

<script>
import ContinueQuote from "../../components/PSContinueQuote.vue";
import { GlobalMethods } from "../../globalMethods";
import FileUpload from 'vue-upload-component'
import { appFunctions } from "../../helpers/appFunctions";
import { peQuoteStatus } from "../../constants/peQuoteStatus";

export default {
  components: {
    ContinueQuote,
    FileUpload
  },
  async mounted() {
    console.log("c13");

  },
  data() {
    return {
      fileList: [],
      uploaderKey: 'quoteFileUploader',
      isUploading: false,
      uploaded: false,
    }
  },
  methods: {
    async uploadFiles() {
      console.log(this.fileList);

      var fileBatch = GlobalMethods.uuidv4();

      var insertedIds = [];

      this.isUploading = true;
      this.uploaded = false;


      for (var file of this.fileList) {

        var attachmentResp = await appFunctions.addLookupFileAttachment({
          Customer_policy_id: this.$route.params.id,
          fileContent: file.fileData,
          filename: file.name,
          guid: GlobalMethods.uuidv4(),
          createdDateTime: new Date(),
          fileBatch,
          type: "ps-policy-doc",
        });

        insertedIds.push(attachmentResp.insertedId);

      };


      //await appFunctions.sendPSQuoteEmail(this.$route.params.id, insertedIds);

      await appFunctions.sendPSPolicyEmail(this.$route.params.id, insertedIds);

      await appFunctions.crud_customerPolicy("updatePSQuoteByGuid", {
        policy_id: this.$route.params.id,
        status: peQuoteStatus.policyDocumentsSent,
      });

      this.isUploading = false;
      this.uploaded = true;


    },
    async customAction(file) {
      const blob = await fetch(file.blob).then((res) => res.blob());
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {

        console.log(file);
        console.log(this.$route.params);

        var base64data = reader.result;

        const filename = file.name;

        var findFile = this.fileList.find(f => f.id == file.id);

        findFile.fileData = base64data;

        /*
        var attachmentResp = await appFunctions.addLookupFileAttachment({
          Customer_policy_id: this.$route.params.id,
          fileContent: base64data,
          filename,
          guid: GlobalMethods.uuidv4(),
          createdDateTime: new Date(),
          type: "ps-policy-doc",
        });

        await appFunctions.sendPSPolicyEmail(this.$route.params.id, attachmentResp.insertedId);

        */

        //console.log(attachmentResp);

        return null;
      };
    },
    /**
     * Has changed
     * @param  Object newFile Read only
     * @param  Object oldFile Read only
     */
    inputFile: function (newFile, oldFile) {

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }

      setTimeout(() => {
        if (
          Boolean(newFile) !== Boolean(oldFile) ||
          oldFile.error !== newFile.error
        ) {
          this.$refs[this.uploaderKey].active = true;
        }
      }, 2000);
    },
    /**
     * Pretreatment
     * @param  Object newFile Read and write
     * @param  Object oldFil  Read only
     * @param  Function prevent Prevent changing
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (!newFile.success) {
        this.$emit("disableNextStep", true)
      } else {
        this.$emit("disableNextStep", false)
      }

      if (newFile && !oldFile) {
        // Filter non-image file
        if (
          !/\.(jpeg|jpe|jpg|gif|png|webp|doc|docx|pdf|xls|xlsx|csv)$/i.test(
            newFile.name
          )
        ) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
  }
};
</script>
